import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../barcodeform.css";

import jQuery from "jquery";

import { getApiBaseUrl , getShypvBaseUrl} from "../../utils/utils";
export default function BulkPrint() {
  const API_URL = process.env.REACT_APP_API_URL;

  const [shipmentDetails, setShipmentDetails] = useState([]);

  const $ = jQuery.noConflict();

  useEffect(() => {
    $(".btn-demo.import").on("click", function () {
      $(".nalier.middle-center.fade").css("display", "block");
      $(".nalier.middle-center.fade").addClass("in");
    });

    $(".close.h-close").on("click", function () {
      $(".nalier.middle-center.fade.in").css("display", "none");
      $(".nalier.middle-center.fade").removeClass("in");
    });
  }, []);

  const buttonsyle = {
    background: "#00a6ed",
    color: "#fff",
    padding: "3px",
    marginRight: "10px",
    borderColor: "#00a6ed",
    cursor: "pointer",
    marginTop: "3%",
  };
  const buttonsyle1 = {
    background: "#00a6ed",
    color: "#fff",
    padding: "3px",
    marginLeft: "75%",
    borderColor: "#00a6ed",
    cursor: "pointer",
    marginTop: "3%",
    marginBottom: "2%",
  };

  const [msg, setMsg] = useState("");
  const [errormsg, setError] = useState("");

  useEffect(() => {
    
    getUserList();
  }, []);

  const [scaninfo, setScaninfo] = useState({
    driver: "",
  });
 
  

  const [users, setusers] = useState();
  const getUserList = async () => {
    const API_PATH = `${API_URL}shypvdriverapp/personnel/getPersonnels`;

    // Send a GET request to the new API
    try {
      const res = await axios.get(API_PATH);

      console.log(res.data); // Log the response to inspect it

      // Check if the response contains 'data' and if it's an array
      if (res.data && res.data.success && Array.isArray(res.data.data)) {
        setusers(res.data.data); // Update the personnel list in the state
      } else {
        console.log(
          "No personnel data found in the response or response is not successful"
        );
      }
    } catch (err) {
      console.log("Error fetching personnel list:", err);
    }
  };


  console.log("scan:", scaninfo);
  console.log("users:", users);
  const getDetails = async () => {
    if (selectedPartner && datechosenfrom) {
      try {
        const response = await axios.get(
          `${API_URL}shypvdriverapp/jobs/job-by-partner`,
          {
            params: {
              partnerId: selectedPartner,
              date: datechosenfrom, // e.g., '2025-07-31'
            },
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        console.log("Response Data:", response.data);

        if (response.data.success && Array.isArray(response.data.data)) {
          const awbs = response.data.data;

          // Optionally filter AWBs or validate if needed
          if (awbs.length > 0) {
            PrintLabel(awbs); // Call your label print function here
          } else {
            console.warn("No AWBs found for the selected criteria.");
            setError("No AWBs found for the selected partner and date.");
          }
        } else {
          setError("No successful response or invalid data format.");
        }
      } catch (err) {
        console.error("Error:", err.response?.data || err.message);
        setError("An error occurred while fetching details");
      }
    } else {
      setError("Please fill the required fields");
    }
  };

  function PrintLabel(awbs) {
    if (!awbs || awbs.length === 0) {
      console.warn("No AWBs to print.");
      return;
    }

    // Normalize AWBs to a comma-separated list
    const awbList = awbs.map((item) => item.trim()).filter(Boolean);
    const awbParam = awbList.join(",");

    // Determine base URL based on current hostname
     const baseUrl = getShypvBaseUrl();
    const url = `${baseUrl}/multi-print-order?id=${awbParam}`;

    console.log("Generated URL:", url);
    window.open(url, "_blank");
  }

  const [driverdata, setdriverdata] = useState({
    driverid: "",
    team: "",
    zone: "",
  });

  const [errorNew, seterrorNew] = useState("");

  console.log("shipmentDetails", shipmentDetails);

  const [datechosenfrom, setdatechosenfrom] = useState();

  const [driver, setdriverchosen] = useState();

  const [partners, setPartners] = useState([]);
  useEffect(() => {
    const fetchPartners = async () => {
      const baseApiUrl = getApiBaseUrl();
      try {
        const response = await axios.get(
          `${baseApiUrl}/v1.0/partner/retrieve_list?page=0`
        );
        setPartners(response.data.data);
      } catch (err) {
        setError(err.message || "Error fetching data");
      } finally {
        // setLoading(false);
      }
    };

    fetchPartners();
  }, []);

  const [selectedPartner, setSelectedPartner] = useState("0");

  const handleSelectChange = (e) => {
    const partnerId = e.target.value;

    if (partnerId === "0") {
      setSelectedPartner("0");

      return;
    }

    const partner = partners.find((p) => String(p.pid) === partnerId);
    setSelectedPartner(partner.pid);
  };

  return (
    <div>
      <div className="form-container">
        <h4>Bulk Print</h4>
        <div className="row">
          <div className="col-md-8">
            <div className="row">
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="driver">Date:</label>
                  <input
                    type="date"
                    id="date"
                    value={datechosenfrom}
                    onChange={(e) => setdatechosenfrom(e.target.value)}
                  />
                </div>
              </div>
            </div>

            {/* Driver Selection */}
            <div className="row">
              <div className="col-md-8">
                <div className="form-group">
                  <label htmlFor="formGroupExampleInput2" className="m-form">
                    Partner*
                  </label>
                  <select
                    onChange={handleSelectChange}
                    value={selectedPartner}
                    style={{ marginRight: "10px" }}
                  >
                    <option value="" disabled>
                      -- Select a partner --
                    </option>
                    <option value="0">All</option>
                    {partners &&
                      [...partners]
                        .sort((a, b) => a.pname.localeCompare(b.pname))
                        .map((partner) => (
                          <option key={partner.pid} value={partner.pid}>
                            {partner.pname}
                          </option>
                        ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-3"></div>
              <div className="col-md-6">
                <a
                  onClick={getDetails}
                  style={buttonsyle}
                  type="button"
                  className="btn-demo add"
                >
                  Print Label
                </a>
              </div>
            </div>
            <p style={{ color: "red", marginTop: "2%" }}>{errormsg}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
